__webpack_require__.p = "/wp-content/themes/sunset-magazine-v4/bundle/";